import { render, staticRenderFns } from "./offline_products.vue?vue&type=template&id=5a897852&scoped=true"
import script from "./offline_products.vue?vue&type=script&lang=js"
export * from "./offline_products.vue?vue&type=script&lang=js"
import style0 from "./offline_products.vue?vue&type=style&index=0&id=5a897852&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a897852",
  null
  
)

export default component.exports